import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useRefreshMutation } from '../redux/services/authApi';

/**
 * This hook handles the initial authentication check when the app loads.
 * It tries to refresh the user's token to re-establish their session.
 */

const useInitialAuth = () => {
  const [triggerRefresh] = useRefreshMutation();

  const { accessToken } = useSelector((state) => state.auth);

  const [isInitializing, setIsInitializing] = useState(true);

  useEffect(() => {
    const initializeSession = async () => {
      if (!accessToken) {
        setIsInitializing(false);
        return;
      }

      await triggerRefresh();
      setIsInitializing(false);
    };

    initializeSession();
  }, []);

  return isInitializing;
};

export default useInitialAuth;
